/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_ErrorInputs */

const en_welcome_phase_error = /** @type {(inputs: Welcome_Phase_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startup failed`)
};

const fr_welcome_phase_error = /** @type {(inputs: Welcome_Phase_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du démarrage`)
};

const ms_sg2_welcome_phase_error = /** @type {(inputs: Welcome_Phase_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permulaan gagal`)
};

/**
* | output |
* | --- |
* | "Startup failed" |
*
* @param {Welcome_Phase_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_error = /** @type {((inputs?: Welcome_Phase_ErrorInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_ErrorInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_error(inputs)
	if (locale === "fr") return fr_welcome_phase_error(inputs)
	return ms_sg2_welcome_phase_error(inputs)
});